import { defineStore } from 'pinia'

export const useFilterStore = defineStore('filter', {
  state: (): {
    search: string
    teams: string[]
  } => ({
    search: '',
    teams: []
  }),
  actions: {}
})
